import React from 'react';
import './style.css';

// Helper function to get card image from card code
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  try {
    if (cardCode.length < 3) {
      return null;
    }
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

// Helper function to extract card rank from card code (e.g., "8CC" -> "8", "KCC" -> "K")
const getCardRank = (cardCode) => {
  if (!cardCode) return '';
  return cardCode.slice(0, -2);
};

// Helper function to parse card string (format: "8CC,7HH,KCC")
const parseCards = (cardString) => {
  if (!cardString) return { cards: [], ranks: [] };
  
  const cardCodes = cardString.split(',');
  const cards = cardCodes.map(code => getCardImage(code.trim())).filter(Boolean);
  const ranks = cardCodes.map(code => getCardRank(code.trim())).filter(Boolean);
  
  return { cards, ranks };
};

const ThreeCardJ = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cardData = detailResult?.card ? parseCards(detailResult.card) : { cards: [], ranks: [] };
  const resultText = cardData.ranks.join('  '); // Join ranks with double space

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <h6 className="text-right">
            <b>Round Id :</b> {roundId}
          </h6>
        </div>
      </div>
      <div className="row bottom-border-casino m-t-10">
        <div className="col-md-12">
          <div className="player-image-container row">
            <div className="text-center player-number col-12">
              {cardData.cards && cardData.cards.length > 0 && (
                <>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                    {cardData.cards.map((cardImage, index) => (
                      <img 
                        key={index}
                        src={cardImage} 
                        alt={`Card ${index + 1}`}
                        onError={(e) => {
                          e.target.src = `/assets/img/cards/patti_back.png`;
                        }}
                      />
                    ))}
                  </div>
                  <div className="col-md-12 text-left">
                    <p className="m-b-0 m-t-20">
                      <b>Result:</b> {resultText}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreeCardJ;

